export default function AdminSidebar({ activeTab, onTabChange, tabs }) {
  return (
    <nav aria-label="Administration sections" className="admin-tabs" role="tablist">
      {tabs.map(([value, label]) => (
        <button aria-controls={`admin-panel-${value}`} aria-selected={activeTab === value} className={activeTab === value ? 'is-active' : ''} id={`admin-tab-${value}`} key={value} onClick={() => onTabChange(value)} role="tab" type="button">
          {label}
        </button>
      ))}
    </nav>
  );
}
